import DOMPurify from "dompurify";

// Configuração de sanitização para conteúdo HTML fornecido pelo usuário.
const CONFIG = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: ["script", "iframe", "object", "embed", "form", "input"],
  FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover"],
  ALLOW_DATA_ATTR: false,
};

const DANGEROUS_CSS_PROPS = new Set(["position", "z-index"]);

// Hook executado após a sanitização de atributos de cada nó.
function hardenNode(node) {
  const style = node && node.style;
  if (style && style.length) {
    const names = [];
    for (let i = 0; i < style.length; i++) names.push(style[i]);
    names.forEach((name) => {
      const value = style.getPropertyValue(name);
      if (DANGEROUS_CSS_PROPS.has(name) || /url\s*\(/i.test(value)) {
        style.removeProperty(name);
      }
    });
  }

  if (node.nodeName === "A" && node.hasAttribute("target")) {
    node.setAttribute("rel", "noopener noreferrer");
  }
}

// Sanitiza uma string de HTML removendo scripts, handlers de evento e CSS
export function sanitizeHtml(dirty) {
  if (!dirty) return "";
  DOMPurify.addHook("afterSanitizeAttributes", hardenNode);
  try {
    return DOMPurify.sanitize(String(dirty), CONFIG);
  } finally {
    DOMPurify.removeHook("afterSanitizeAttributes");
  }
}

// Escapa caracteres especiais para renderizar texto puro sem interpretar HTML.
export function escapeHtml(str) {
  if (!str) return "";
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
